import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Langs } from '@purplefront/shared';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { PreferencesState, selectContentLang } from '@purplefront/preferences/data-access';
import { takeUntil } from 'rxjs/operators';
import { AppRouterState, selectSearchString } from '@purplefront/app-router/data-access';

@Component({
  selector: 'app-search-not-found',
  templateUrl: './search-not-found.component.html',
  styleUrls: ['./search-not-found.component.scss']
})
export class SearchNotFoundComponent implements OnInit, OnDestroy {
  contentLang: Langs;
  searchString$: Observable<string>;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private _router: Router,
    private _prefStore: Store<PreferencesState>,
    private _routerStore: Store<AppRouterState>
  ) {}

  ngOnInit(): void {
    this.searchString$ = this._routerStore.pipe(select(selectSearchString));

    this._prefStore.pipe(select(selectContentLang), takeUntil(this._ngUnsubscribe$)).subscribe((lang) => {
      this.contentLang = lang;
    });
  }
  goToSearchPage() {
    this._router.navigate(['searchPage', this.contentLang]);
  }
  ngOnDestroy() {
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }
}
